<template>
    <div class="page-container">
        <div class="area-container">
            <CommonTree
                type="room"
                :showFilter="true"
                @change="handleNodeClick"
                :customStyle="{ borderRight: 'none', width: '100%' }"
            />
        </div>
        <div class="data-container">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button
                    type="primary"
                    plain
                    @click="valveOpening(selected_ids, 0)"
                    v-permission="['control-valve:params-config:valve-opening']"
                >
                    阀门开度
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="tempSetting(selected_ids, 0, 0, 0, 0)"
                    v-permission="['control-valve:params-config:temp-threshold']"
                >
                    水温设置
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="uploadCycle(selected_ids, 30)"
                    v-permission="['control-valve:params-config:report-cycle']"
                >
                    上传周期
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="acquisitionCycle(selected_ids, 0)"
                    v-permission="['control-valve:params-config:acquisition-cycle']"
                >
                    采集周期
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="showPanel(selected_ids, true)"
                    v-permission="['control-valve:params-config:show-panel']"
                >
                    面板显示
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="handleDeviceUpgrade(selected_ids)"
                    v-permission="['control-valve:params-config:device-upgrade']"
                >
                    设备升级
                </el-button>
                <el-button type="primary" plain @click="preventOpen(selected_ids, true)">防拆开关</el-button>
                <el-button
                    type="primary"
                    plain
                    @click="motorAction(selected_ids)"
                    v-permission="['control-valve:params-config:motor-action']"
                >
                    电机操作
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="handleClearParams(selected_ids)"
                    v-permission="['control-valve:params-config:clear-params']"
                >
                    清除下发参数
                </el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="户名" prop="name">
                    <el-input style="width: 165px" v-model="search_params.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态" prop="online">
                    <el-select v-model="search_params.online" placeholder="请选择状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI" prop="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="search_params.IMEI" clearable />
                </el-form-item>
                <el-form-item label="ICCID" prop="ICCID">
                    <el-input style="width: 165px" placeholder="请输入ICCID" v-model="search_params.ICCID" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                row-key="id"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" />
                <el-table-column label="户名" fixed="left" prop="name" width="130px" show-overflow-tooltip></el-table-column>
                <el-table-column label="安装位置" min-width="500" prop="location" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span>{{ room_list[row.room] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="阀门开度" width="90" prop="opening_setting">
                    <template #default="{ row }">
                        <span v-if="row.opening_setting !== undefined">{{ row.opening_setting }}%</span>
                    </template>
                </el-table-column>
                <el-table-column label="上传周期（分钟）" width="90" prop="report_cycle">
                    <template #default="{ row }">
                        <span>{{ row.report_cycle ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="采集周期（分钟）" width="90" prop="acquisition_cycle">
                    <template #default="{ row }">
                        <span>{{ row.acquisition_cycle ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="面板显示" width="90" prop="show_panel">
                    <template #default="{ row }">
                        <el-tag v-if="row.show_panel" type="success">显示</el-tag>
                        <el-tag v-else type="info">不显示</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="IMEI" width="150px" prop="IMEI"></el-table-column>
                <el-table-column label="设备类型型号" width="220" prop="device_type">
                    <template #default="{ row }">
                        <span>{{ row.model ? model_list[row.model].type + '/' + model_list[row.model].model : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="380">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="valveOpening([row.id], row.opening_setting)"
                            v-permission="['control-valve:params-config:valve-opening']"
                        >
                            阀门开度
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="tempSetting([row.id], row)"
                            v-permission="['control-valve:params-config:temp-threshold']"
                        >
                            水温设置
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="uploadCycle([row.id], row.report_cycle)"
                            v-permission="['control-valve:params-config:report-cycle']"
                        >
                            上传周期
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="acquisitionCycle([row.id], row.acquisition_cycle)"
                            v-permission="['control-valve:params-config:acquisition-cycle']"
                        >
                            采集周期
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="showPanel([row.id], row.show_panel)"
                            v-permission="['control-valve:params-config:show-panel']"
                        >
                            面板显示
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="handleDeviceUpgrade([row.id])"
                            v-permission="['control-valve:params-config:device-upgrade']"
                        >
                            设备升级
                        </el-button>
                        <!-- <el-button
                            type="primary"
                            link
                            size="small"
                            @click="handleClearParams([row.id])"
                            v-permission="['control-valve:params-config:clear-params']"
                        >
                            清除下发参数
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
            <water-temp v-if="temp_dialog_show" v-model="temp_dialog_show" :detailData="temp_detail" @updateForm="getTableData" />
        </div>
    </div>
</template>

<script setup>
import { h, onMounted, reactive, ref } from 'vue'
import { Refresh, Search } from '@element-plus/icons'
import { batchPatchValveParams, devicesUpgrade, getDeviceList } from '@/api/heating/devicePoint/devicePoint.js'
import Pagination from '@/components/Pagination/index.vue'
import CommonTree from '@/components/BuildTree/CommonTree.vue'
import { getEquipModelTree } from '@/api/equipment.js'
import { getOptionTree } from '@/api/room.js'
import { ElInputNumber, ElMessage, ElMessageBox, ElRadio, ElRadioGroup, ElSwitch } from 'element-plus'
import WaterTemp from '@/views/control-valve/params-config/batchConfig/components/WaterTemp.vue'

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        const room_locations = {}
        function getRoom(list, location) {
            list.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }
        getRoom(data ? data?.[0]?.children : [], '')
        room_list.value = room_locations
    })
}

// 状态列表
const statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 左侧区域树
const current_node = ref({})
const handleNodeClick = (data) => {
    current_node.value = data
    resetQueryForm()
}

// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    name: '',
    online: null,
    IMEI: '',
    ICCID: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_params, ...page_params }
    if (current_node.value?.id) {
        if (current_node.value?.node_type !== undefined) {
            params.building = current_node.value.id
        } else {
            params.room = current_node.value.id
        }
    }
    params.type = 3
    getDeviceList(params).then((data) => {
        table_data.value = data.lists
        total.value = data.total
        tableLoading.value = false
    })
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表格项被勾选
const selected_ids = ref([])
function handleSelectionChange(rows) {
    selected_ids.value = rows.map((item) => item.id)
}

// 阀门开度
function valveOpening(ids, value) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(value)
    const placeholder_value = ref('未知')
    ElMessageBox({
        title: '阀门开度',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: 0,
                    max: 100,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                        if (!val) {
                            placeholder_value.value = ''
                        }
                    },
                    placeholder: placeholder_value.value
                }),
                h('span', ' %')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value >= 0) {
                    instance.confirmButtonLoading = true
                    batchPatchValveParams({
                        type: 3,
                        id_list: ids,
                        opening_setting: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入阀门开度值')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 水温设置
const temp_dialog_show = ref(false)
const temp_detail = ref({})
function tempSetting(ids, row) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    temp_detail.value = {
        id_list: ids,
        ...row
    }
    temp_dialog_show.value = true
}

// 上传周期
function uploadCycle(ids, value) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(value)
    const placeholder_value = ref('未知')
    ElMessageBox({
        title: '上传周期',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: 1,
                    max: 2880,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                        if (!val) {
                            placeholder_value.value = ''
                        }
                    },
                    placeholder: placeholder_value.value
                }),
                h('span', ' 分钟')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value) {
                    instance.confirmButtonLoading = true
                    batchPatchValveParams({
                        type: 3,
                        id_list: ids,
                        report_cycle: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入上传周期')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 采集周期
function acquisitionCycle(ids, value) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(value)
    const placeholder_value = ref('未知')
    ElMessageBox({
        title: '采集周期',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: 1,
                    max: 2880,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                        if (!val) {
                            placeholder_value.value = ''
                        }
                    },
                    placeholder: placeholder_value.value
                }),
                h('span', ' 分钟')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value) {
                    instance.confirmButtonLoading = true
                    batchPatchValveParams({
                        type: 3,
                        id_list: ids,
                        acquisition_cycle: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入上传周期')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 面板显示
function showPanel(ids, value) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(value)
    ElMessageBox({
        title: '面板是否显示温湿度',
        message: () => {
            return h(ElSwitch, {
                modelValue: checked.value,
                activeText: '是',
                inactiveText: '否',
                'onUpdate:modelValue': (val) => {
                    checked.value = val
                }
            })
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true
                batchPatchValveParams({
                    type: 3,
                    id_list: ids,
                    show_panel: checked.value
                })
                    .then(() => {
                        instance.confirmButtonLoading = false
                        ElMessage.success('设置成功！')
                        getTableData()
                        done()
                    })
                    .catch(() => {
                        instance.confirmButtonLoading = false
                    })
            } else {
                done()
            }
        }
    })
}
const preventOpen = (ids, value) => {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(value)
    ElMessageBox({
        title: '防拆开关是否禁用',
        message: () => {
            return h(ElSwitch, {
                modelValue: checked.value,
                activeValue: 1,
                inactiveValue: 0,
                activeText: '是',
                inactiveText: '否',
                'onUpdate:modelValue': (val) => {
                    checked.value = val
                }
            })
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true
                batchPatchValveParams({
                    type: 3,
                    id_list: ids,
                    tamper_proof: checked.value
                })
                    .then(() => {
                        instance.confirmButtonLoading = false
                        ElMessage.success('设置成功！')
                        getTableData()
                        done()
                    })
                    .catch(() => {
                        instance.confirmButtonLoading = false
                    })
            } else {
                done()
            }
        }
    })
}

// 电机操作
function motorAction(ids) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    const checked = ref(0)
    const options = [
        { label: '无动作', value: 0 },
        { label: '校正阀门', value: 1 },
        { label: '防止阀门生锈', value: 2 }
    ]
    ElMessageBox({
        title: '电机动作模式',
        message: () => {
            return h(
                ElRadioGroup,
                {
                    modelValue: checked.value,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                    }
                },
                () => options.map((opt) => h(ElRadio, { key: opt.value, value: opt.value }, () => opt.label))
            )
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true
                batchPatchValveParams({
                    // type: 3,
                    id_list: ids,
                    motor_action: checked.value
                })
                    .then(() => {
                        instance.confirmButtonLoading = false
                        ElMessage.success('设置成功！')
                        getTableData()
                        done()
                    })
                    .catch(() => {
                        instance.confirmButtonLoading = false
                    })
            } else {
                done()
            }
        }
    })
}

// 设备升级
function handleDeviceUpgrade(ids) {
    ElMessageBox.confirm('是否确认升级设备？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        devicesUpgrade({
            type: 3,
            id_list: ids
        }).then(() => {
            ElMessage.success('操作成功！')
        })
    })
}

// 清除下发参数
function handleClearParams(ids) {
    if (ids.length === 0) {
        ElMessage.error('请选择设备')
        return false
    }
    ElMessageBox.confirm('是否确认清除下发参数？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        batchPatchValveParams({
            // type: 3,
            id_list: ids,
            clear_params: 1
        }).then(() => {
            ElMessage.success('操作成功！')
        })
    })
}

// 切换到前台时候执行
onMounted(() => {
    getModelList()
    getRoomTree()
    getTableData()
})
</script>

<style scoped></style>
